<template>
  <div class="notice-list">
    <Datatable
      url="/Member/RZJInfoCenter/NewList"
      field="NewList"
      :th="[$t('label.w125')+'/'+$t('label.w123')]"
      v-slot="{item}"
      :tip="$t('msg.m118')"
    >
    <tr>
        <td class="td" @click="getdetail(item.Id)">
            <p class="p1">{{item.Subject}}</p>
            <p >{{item.CreatedAt}}</p>
        </td>
    </tr>
    </Datatable>
  </div>
</template>

<script>
import Datatable from "@/components/datatable";
export default {
  components: { Datatable },
  methods:{
      getdetail(id){
          this.$router.push({
          name: 'noticeDetail',
          query: {
            id: id
          }
        })
      }
  }
};
</script>

<style lang="less" scoped>
.notice-list {
  margin-top: 30px;
  min-height: 600px;
  /deep/.thead{
      th:last-child{
          border-radius: 10px 10px 0 0;
      }
  }
  tbody tr{
      height: 60px;
      .td{
          background: url("../../assets/pubilc_more.png") no-repeat;
          background-position: 97%;
          background-size: 5px 11px;
          color: #7B7B7C;
          font-size: 12px;
          cursor: pointer;
          .p1{
              font-size: 14px;
              color: #333;
          }
      }
  }
}
</style>
